export enum Country {
    Be = "BE",
    Fr = "FR"
}
